// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__+ToVy"};